import { IonGrid, IonRow, IonCol, IonButton, IonIcon } from '@ionic/react';
import React, { useContext, useRef, useState } from 'react';
import { AppContext } from 'context/app.context';
import { createPHQ, importForm } from 'misc/phqHTTP';
import { QuestionnaireModel } from 'models/questionnaire.model';
import FadeIn from '../animations/fadeIn';
import Input from '../UI/Input/Input';
import TextArea from '../UI/TextArea/TextArea';
import { AxiosResponse } from 'axios';
import { HttpStatusCodeEnum } from 'models/http-status-code.enum';
import { cloudUploadOutline } from 'ionicons/icons';


const NewPHQ = (props: { fnUpdateList: () => void; fnToHideForm: (arg0: boolean) => void; }) => {

    const { domain, isLoading, setIsLoading, notifySuccess } = useContext(AppContext)

    const [label, dispatchLabel] = useState('');
    const [description, dispatchDescription] = useState('');
    const inputEl = useRef<HTMLInputElement>(null);

    const createNewPHQ = (e:any) => {
        e.stopPropagation();

        const payload = new QuestionnaireModel();
        payload.Domain = domain.Code;
        payload.Description = description;
        payload.Label = label;
        payload.IsActive = true;
        payload.CreatedBy = 0;

        setIsLoading(true);
        createPHQ(payload).then((res: AxiosResponse<any>) => {
            setIsLoading(false);
            if (res.status === HttpStatusCodeEnum.CREATED) {
                props.fnUpdateList();
                props.fnToHideForm(false);
            }   
        })
    }

    const importPHQ = (e: any) => {
        e.persist();
        if (e.target.files.length > 0) {
            setIsLoading(true);
            const formData = new FormData();
            formData.append("file", e.target.files[0]);
            formData.append("domain", domain.Code);
            if (label?.length > 0) {
                formData.append("label", label);
            }
            
            importForm(formData)
            .then(_ => {
                notifySuccess("Form imported successfully");
                props.fnUpdateList();
                props.fnToHideForm(false);
            })
            .finally(() => setIsLoading(false));
        }
    }

    const onTriggerFileImport = (e:any) => {
        inputEl?.current?.click();
        e.stopPropagation();
    }

    return (<FadeIn>
        <form className='ion-padding'>
            <IonGrid className='ion-no-padding'>
                <IonRow className='ion-padding-bottom'>
                    <IonCol size='6'>
                        <Input inputtype='input' disabled={true} type='text' id="Name" name='Name' placeholder="Name will be autogenerated" />
                    </IonCol>
                    <IonCol size='6'>
                        <Input 
                            id="Label"
                            inputtype='input'
                            type='text'
                            name='Label' 
                            value={label}
                            onIonChange={(e: React.ChangeEvent<HTMLInputElement>) => { dispatchLabel(e.target.value) }}
                        />
                    </IonCol>
                </IonRow>
                <IonRow className='ion-padding-bottom'>
                    <IonCol size='12'>
                        <TextArea autoGrow={true} id="Description" name='Description' value={description}
                            onIonBlur={(e: any) => { dispatchDescription(e.target.value) }} />
                    </IonCol>
                </IonRow>
                <IonRow>
                    <IonCol size='12' className="create-btn-container">
                        <IonButton className="ipro-btn ion-float-right" color="primary" disabled={isLoading} onClick={onTriggerFileImport}>
                            <IonIcon icon={cloudUploadOutline} /> { isLoading ? "Loading..." : "Import" }
                            <input ref={inputEl} type="file" hidden onChange={e => importPHQ(e)} accept=".json" />
                        </IonButton>
                        <IonButton className="ipro-btn ion-float-right" color="primary" disabled={isLoading} onClick={createNewPHQ}>Create</IonButton>
                        <IonButton className="ipro-btn ion-float-right" color="danger" disabled={isLoading} onClick={() => { props.fnToHideForm(false) }}>Cancel</IonButton>
                    </IonCol>
                </IonRow>
            </IonGrid>
        </form>
    </FadeIn>
    )
};

export default NewPHQ;
